import { SkeletonFrame } from '@nextgen-web-framework/all';
import styles from './FrameRectangle.module.scss';

type FrameRectangleProps = {
  height?: string;
  width?: string;
  borderRadius?: string;
  className?: string;
};
export const FrameRectangle = ({ height, width, borderRadius, className = '' }: FrameRectangleProps) => (
  <div className={`${styles['frame-rectangle']} ${className}`}>
    <SkeletonFrame
      className={className}
      isRoundCorner={true}
      heightValue={height}
      widthValue={width}
      borderRadiusValue={borderRadius}
    />
  </div>
);
